module.exports = __webpack_public_path__ + "static/media/sliderHome2.c802df8b.jpg";